import { AscButtonShareCommonPropsI } from "../AscButtonShare.type";
import styles from "./AscButtonShareTwitter.module.scss";
import classNames from "classnames";
import { TwitterWhiteIcon } from "../../AscIcons";

function AscButtonShareTwitter({
  className,
  label = "Twitter",
  link,
}: AscButtonShareCommonPropsI) {
  return (
    <button
      className={classNames(className, styles.element)}
      data-sharer="twitter"
      data-title="Completed course on the platform The Edge"
      data-hashtags="ascend,certificate"
      data-url={link}
    >
      <TwitterWhiteIcon className={styles.icon} />
      {label}
    </button>
  );
}

export default AscButtonShareTwitter;
